import MenuInTree from './MenuInTree';

export default MenuInTree;
